@if (!hideTitle()) {
  <miq-filter-bar-label [props]="props()"></miq-filter-bar-label>
}
<div class="simpleselect_dropdown">
  <mat-form-field appearance="outline">
    <mat-select
      disableOptionCentering
      hideSingleSelectionIndicator="true"
      panelClass="select-multiple-drop-panel searchable-multi-select-panel"
      [formControl]="mainValueControl"
      (keydown)="onKeyDown($event)"
      [placeholder]="props().placeholder || ('shared.select' | translate)"
      [disabled]="disabled()"
      (selectionChange)="onSelectionChanged()"
      (openedChange)="openedChange($event)"
      multiple
    >
      @if (props().hasFilter) {
        <ng-container
          *ngTemplateOutlet="
            searchableMultiSelectFilter;
            context: {
              optionsFilterControl: optionsFilterControl,
              filteredOptions: filteredOptions | async,
            }
          "
        ></ng-container>
      }
      @for (option of filteredOptions | async; track option) {
        <mat-option class="checkbox-customization" [value]="option[dataKey]">
          @if (props().translateOptionsRequired) {
            {{ (option.value || option.key | translate | uppercase) || '-' }}
          } @else {
            {{ (option.value || option.key | uppercase) || '-' }}
          }
        </mat-option>
      }
    </mat-select>
    @if (displayClearButton && (mainValueControl?.value || mainValueControl?.value?.length)) {
      <button
        type="button"
        class="multiselect-clear pi pi-times-circle"
        aria-label="Clear selections"
        (click)="clearFilter()"
      ></button>
    }
  </mat-form-field>
</div>

<ng-template
  #searchableMultiSelectFilter
  let-optionsFilterControl="optionsFilterControl"
  let-filteredOptions="filteredOptions"
>
  <div class="ss-search-box-container searchable-multi-select-search-box">
    <input
      [formControl]="optionsFilterControl"
      type="text"
      (keydown)="onKeyDown($event)"
      autocomplete="off"
      aria-label="Filter options"
      [placeholderLabel]="'shared.find' | translate"
      class="ss-search-box-container-input"
    />
    @if (optionsFilterControl?.value?.length > 0) {
      <mat-icon
        class="ss-search-box-clear"
        role="button"
        tabindex="0"
        (click)="clearSearchFilter()"
        (keydown.enter)="clearSearchFilter()"
      >close</mat-icon>
    }
  </div>

  @if (filteredOptions?.length === 0) {
    <mat-option disabled class="ss-no-matches checkbox-customization">
      {{ 'shared.noMatchFound' | translate }}
    </mat-option>
  }
</ng-template>